import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Badge,
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import { format } from 'date-fns';
import exportFromJSON from 'export-from-json';
import { useEffect, useRef, useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { IoIosAlert } from 'react-icons/io';
import { Link, useLocation } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import { FireIcon } from '../../../../../assets/icons/FireIcon';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getTelephoneOrCellPhoneNumber } from '../utils/getTelephoneOrCellPhoneNumber';

export const KanbanVendedorMobile = (): JSX.Element => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenFilter,
    onOpen: onOpenFilter,
    onClose: onCloseFilter
  } = useDisclosure();
  const {
    isOpen: isOpenDetails,
    onOpen: onOpenDetails,
    onClose: onCloseDetails
  } = useDisclosure();
  const { state }: any = useLocation();
  const [details, setDetails] = useState<any>({
    name: '',
    email: '',
    cel: '',
    campaign: '',
    id: '',
    status: '',
    cpf: '',
    id_mdm: '',
    data_criacao: 0,
    segmento: '',
    lote: '',
    data_campanha: '',
    objetivo_campanha: '',
    descritivo_campanha: ''
  });
  const [values, setValues] = useState({
    totalLead: state.vendedor.quantidade_leads_recebidos || 0,
    totalLeadsAtendidos: state.vendedor.quantidade_leads_atendidos || 0,
    leadsNaoAtendidos: state.vendedor.quantidade_leads_naoAtendidos || 0,
    clientesAguardandoRetorno: state.vendedor.quantidade_leads_nao_atendeu || 0
  });
  const [history, setHistory] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);

  const [changeVendedor, setChangeVendedor] = useState({
    id: '',
    codigo_produtor: '',
    tipo: '',
    telefone_2: '',
    telefone_1: '',
    id_atualizacao: '',
    id_gestor: '',
    nome: '',
    email: '',
    status: '',
    leads_usuario: {
      novoContato: [],
      emNegociacao: [],
      concluidos: [],
      naoAtendidos: []
    },
    quantidade_leads_recebidos: 1,
    quantidade_leads_atendidos: 1,
    quantidade_leads_naoAtendidos: 0,
    quantidade_leads_leadsHot: 0,
    quantidade_leads_nao_atendeu: 0,
    taxa_sucesso: ''
  });
  const [vendedoresDisponiveis, setVendedoresDisponiveis] = useState([
    {
      id: '',
      codigo_produtor: '',
      tipo: '',
      telefone_2: '',
      telefone_1: '',
      id_atualizacao: '',
      id_gestor: '',
      nome: '',
      email: '',
      status: '',
      leads_usuario: {
        novoContato: [],
        emNegociacao: [],
        concluidos: [],
        naoAtendidos: []
      },
      quantidade_leads_recebidos: 1,
      quantidade_leads_atendidos: 1,
      quantidade_leads_naoAtendidos: 0,
      quantidade_leads_leadsHot: 0,
      quantidade_leads_nao_atendeu: 0,
      taxa_sucesso: ''
    }
  ]);
  const [leads, setLeads] = useState<any>(
    [...state.vendedor.leads_usuario.naoAtendidos] || []
  );
  const [AllLeads, setAllLeads] = useState<any>({
    oportunidades: [...state.vendedor.leads_usuario.naoAtendidos] || [],
    novoContato: [...state.vendedor.leads_usuario.novoContato] || [],
    emNegociacao: [...state.vendedor.leads_usuario.emNegociacao] || [],
    concluidos: [...state.vendedor.leads_usuario.concluidos] || []
  });
  const leadsJuntos = useRef<any>([
    {
      name: 'teste',
      email: 'teste@teste',
      cel: '343434',
      campaign: 'campanha teste'
    }
  ]);

  const [selectedStatus, setSelectStatus] = useState<any>({
    name: 'Novas Oportunidades',
    color: '#FA6B25',
    id: 1,
    items: [],
    status: 'Oportunidades'
  });

  const [statusStep, setStatusStep] = useState<any>([
    {
      name: 'Novas Oportunidades',
      color: '#FA6B25',
      id: 1,
      items: [],
      status: 'oportunidades'
    },
    {
      name: 'Fazer novo contato',
      color: '#146CFA',
      id: 2,
      items: [],
      status: 'novoContato'
    },
    {
      name: 'Em negociação',
      color: '#00335E',
      id: 3,
      items: [],
      status: 'emNegociacao'
    },
    {
      name: 'Concluído',
      color: '#006217',
      id: 4,
      items: [],
      status: 'concluidos'
    }
  ]);

  const toast = useToast();
  const handleChangeStatus = (status: string) => {
    const getStatus = statusStep.find(
      (element: any) => element.status === status
    );
    const getLeads = AllLeads[status];

    setSelectStatus({ ...getStatus });
    setLeads([...getLeads]);
  };
  const setReason = (reason: string) => {
    switch (reason) {
      case 'lgpd-bloqueado':
        return 'Bloqueado para contato; (LGPD) cliente diz não ter solicitado contato';
      case 'nao-responde':
        return 'Não responde | sem interação nos contatos realizados';
      case 'dados-invalidos':
        return 'Dados inválidos';
      case 'preco':
        return 'Preço';
      case 'fora-rede':
        return 'Fora da rede credenciada | Fora da área de abrangência | Localização';
      case 'concorrencia':
        return 'Concorrência | Fechou com outra Seguradora | Atendido por outro Corretor';
      case 'cnpj-inativo':
        return 'CNPJ inativo | Emissão de certidão negativa';
      case 'mei-menos':
        return 'MEI menos de 6 meses';
      case 'ja-contratou':
        return 'Já contratou';
      case 'converteu-saude':
        return 'Interesse em outros produtos | Converteu Saúde';
      case 'converteu-odonto':
        return 'Interesse em outros produtos | Converteu Odonto';
      case 'converteu-vida':
        return 'Interesse em outros produtos | Converteu Vida';
      case 'converteu-viagem':
        return 'Interesse em outros produtos | Converteu Viagem';
      case 'sem-interesse':
        return 'Não teve interesse';
      case 'recusa-sula':
        return 'Recusa SulAmérica DPS';
      default:
        return false;
    }
  };

  const formatDisplayDate = (dateString: string): string => {
    const dateParts = dateString.split('-');

    if (dateParts.length === 3) {
      const [year, month, day] = dateParts;
      return `${day}/${month}/${year}`;
    }

    return '-';
  };

  const handleDetails = async (item: any, cor_coluna, nome_status) => {
    setDetails({ ...item, cor_coluna, nome_status });
    getHistoryData(item.id);
    onOpenDetails();
  };

  const getHistoryData = async (id: string) => {
    setHistoryLoading(true);

    try {
      const { data } = await apiSensedia.get(
        `oportunidades-sulamerica/painel-leads/consultar-lead-historico/${id}`,
        {
          timeout: 0
        }
      );
      setHistory(data);
      setHistoryLoading(false);
    } catch (error: any) {
      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });

      setHistory([]);
      setHistoryLoading(false);
    }
  };

  const exportData = async () => {
    if (leads.length === 0) {
      toast({
        position: 'top',
        description: 'Não existem leads para serem exportados',
        status: 'error',
        duration: 7000,
        isClosable: true
      });
      return;
    }
    const data = leadsJuntos.current.map((lead) => {
      return {
        id_lead: lead.ID_LEAD__c,
        id_mdm: lead.ID_MDM__c,
        data_criacao: lead.CreatedDate,
        nome: lead.NOME__c,
        cpf: lead.CPF__c,
        telefone: lead.TELEFONE__c,
        celular: lead.CELULAR__c,
        email: lead.EMAIL__c,
        segmento: lead.SEGMENTO__c,
        nome_corretor: lead.NOME_CORRETOR__c,
        EV: lead.ESTRUTURA_VENDA__c,
        codigo_produtor: lead.CODIGO_PRODUTOR__c,
        status_lead: lead.STATUS__c,
        campanha: lead.Campanha__c,
        lote: lead.LOTE__c,
        data_campanha: lead.DATA_CAMPANHA__c,
        objetivo_campanha: lead.OBJETIVO_CAMPANHA__c,
        descritivo_campanha: lead.DESCRITIVO_CAMPANHA__c
      };
    });
    const fileName = `Export-lead`;
    const exportType = exportFromJSON.types['csv'];

    exportFromJSON({ data, fileName, exportType });
  };

  const handleCarregarDados = () => {
    setVendedoresDisponiveis([...state.perfis]);
    // setNomeVendedor(state.vendedor.nome);
    setChangeVendedor(state.vendedor);
    const cards = {
      [uuid()]: {
        name: 'Novas Oportunidades',
        color: '#FA6B25',
        items: state.vendedor.leads_usuario.naoAtendidos || [],
        id: 1,
        status: 'Oportunidades'
      },
      [uuid()]: {
        name: 'Fazer novo contato',
        color: '#146CFA',
        items: state.vendedor.leads_usuario.novoContato || [],
        id: 2,
        status: 'NovoContato'
      },
      [uuid()]: {
        name: 'Em negociação',
        color: '#00335E',
        items: state.vendedor.leads_usuario.emNegociacao || [],
        id: 3,
        status: 'EmNegociacao'
      },
      [uuid()]: {
        name: 'Concluído',
        color: '#006217',
        items: state.vendedor.leads_usuario.concluidos || [],
        id: 4,
        status: 'Concluido'
      }
    };

    leadsJuntos.current = [
      ...state.vendedor.leads_usuario.naoAtendidos,
      ...state.vendedor.leads_usuario.novoContato,
      ...state.vendedor.leads_usuario.emNegociacao,
      ...state.vendedor.leads_usuario.concluidos
    ];

    setAllLeads({
      oportunidades: [...state.vendedor.leads_usuario.naoAtendidos],
      novoContato: [...state.vendedor.leads_usuario.novoContato],
      emNegociacao: [...state.vendedor.leads_usuario.emNegociacao],
      concluidos: [...state.vendedor.leads_usuario.concluidos]
    });
    setLeads([...state.vendedor.leads_usuario.naoAtendidos]);
    setLeads(cards);
  };

  return (
    <Box mt="1rem">
      <Box display="flex" w="100%" justifyContent="start" alignItems="start">
        {' '}
        <div className="tw-mb-[2vh] tw-mx-2">
          <Link className="tw-text-[1rem]" to={'/corretor/leads/perfis'}>
            <button className="tw-font-bold tw-text-[#001E64]">
              <Icon as={AiOutlineArrowLeft} mr="0.5rem" />
              Voltar
            </button>
          </Link>
        </div>
      </Box>
      <Flex flexDir={'column'} alignItems="center">
        <Box
          display="flex"
          w="100%"
          alignItems="center"
          px="0.5rem"
          justifyContent="space-between"
        >
          <Box
            w={'30vw'}
            h={' 13vh'}
            bg="#fff"
            boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
            borderRadius="0.8rem"
            display="flex"
            pb="2vh"
            alignItems="center"
            justifyContent="center"
            flexDir="column"
          >
            <Text fontWeight="bold" fontSize={' 5vh'}>
              {!loading ? (
                values.totalLead
              ) : (
                <Flex w="100%" justify="center">
                  <Spinner />
                </Flex>
              )}
            </Text>
            <Text fontSize={' 1.4vh'} align="center">
              Total de leads Recebidos
            </Text>
          </Box>
          <Box
            w={'30vw'}
            h={' 13vh'}
            boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
            bg="#fff"
            borderRadius="0.8rem"
            display="flex"
            pb="2vh"
            alignItems="center"
            justifyContent="center"
            flexDir="column"
          >
            <Text fontWeight="bold" fontSize={'5vh'}>
              {!loading ? (
                values.totalLeadsAtendidos
              ) : (
                <Flex w="100%" justify="center">
                  <Spinner />
                </Flex>
              )}
            </Text>
            <Text fontSize={' 1.5vh'} align="center">
              Total de leads Atendidos
            </Text>
          </Box>
          <Box
            w={'30vw'}
            h={' 13vh'}
            bg="#fff"
            borderRadius="0.8rem"
            display="flex"
            alignItems="center"
            boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
            justifyContent="center"
            flexDir="column"
            pb="2vh"
          >
            <Text fontWeight="bold" fontSize={' 5vh'}>
              {!loading ? (
                values.leadsNaoAtendidos
              ) : (
                <Flex w="100%" justify="center">
                  <Spinner />
                </Flex>
              )}
            </Text>
            <Text fontSize={' 1.5vh'} align="center">
              Leads não atendidos
            </Text>
          </Box>
        </Box>
        {values.clientesAguardandoRetorno > 0 && (
          <Box w="100%">
            <Box
              mt="0.5rem"
              mx="0.5rem"
              h={'9vh'}
              bg={values.clientesAguardandoRetorno > 0 ? '#F5E0DF' : '#fff'}
              border={
                values.clientesAguardandoRetorno > 0
                  ? 'solid #AA2C23 0.1rem'
                  : '0'
              }
              borderRadius="0.8rem"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDir="column"
            >
              <Text
                fontWeight="bold"
                color={
                  values.clientesAguardandoRetorno > 0 ? '#AA2C23' : 'gray.900'
                }
                fontSize={'3vh'}
              >
                {!loading ? (
                  values.clientesAguardandoRetorno
                ) : (
                  <Flex w="100%" justify="center">
                    <Spinner />
                  </Flex>
                )}
              </Text>
              <Box display="flex" alignItems="center" justifyContent="center">
                {values.clientesAguardandoRetorno > 0 && (
                  <IoIosAlert size="1.5rem" color="#AA2C23" />
                )}
                <Text
                  fontSize={'1.5vh'}
                  color={
                    values.clientesAguardandoRetorno > 0
                      ? '#AA2C23'
                      : 'gray.900'
                  }
                  align="center"
                >
                  Ligações não atendidas
                </Text>
              </Box>
            </Box>
          </Box>
        )}
        <Flex justify="center" w="100%">
          <Box
            w="100%"
            mx="0.5rem"
            justifyContent="space-between"
            alignItems="center"
            display="flex"
          >
            <Text
              fontWeight="medium"
              bg={selectedStatus.color}
              w="100%"
              mt="1rem"
              py="0.5rem"
              borderRadius="1.5rem"
              color="#fff"
              fontSize={'1.8vh'}
            >
              <Select
                textAlign="center"
                fontWeight="medium"
                variant="unstyled"
                value={selectedStatus.status}
                onChange={(e) => {
                  handleChangeStatus(e.target.value);
                }}
              >
                <option value="oportunidades" style={{ color: 'black' }}>
                  Novas Oportunidades ({AllLeads.oportunidades.length})
                </option>
                <option value="novoContato" style={{ color: 'black' }}>
                  Fazer novo contato ({AllLeads.novoContato.length})
                </option>
                <option value="emNegociacao" style={{ color: 'black' }}>
                  Em negociação ({AllLeads.emNegociacao.length})
                </option>
                <option value="concluidos" style={{ color: 'black' }}>
                  Concluído ({AllLeads.concluidos.length})
                </option>
              </Select>
            </Text>
          </Box>
        </Flex>
      </Flex>
      <Accordion
        allowMultiple
        h="60vh"
        sx={{
          '&::-webkit-scrollbar': {
            width: '0.4rem',
            borderRadius: '8px',
            backgroundColor: `rgba(0, 0, 0, 0.05)`
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '8px',
            backgroundColor: `#939393`
          }
        }}
      >
        {!loading ? (
          leads.map((item: any, index: number) => {
            return (
              <AccordionItem
                key={index}
                mx="0.5rem"
                mt="1rem"
                bg="#fff"
                borderRadius="0.5rem"
                borderLeft={`4px solid ${selectedStatus.color}`}
              >
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Text>{item.NOME__c}</Text>
                        {item?.SOLICITOU_CONTATO__c === 'true' && (
                          <FireIcon w="0.75rem" h="1rem" />
                        )}
                      </Box>
                      <Flex
                        textAlign="left"
                        borderRadius="2rem"
                        fontSize="0.8rem"
                        alignItems="center"
                        justifyContent="flex-start"
                      >
                        <Badge textColor="#fff" bg={selectedStatus.color}>
                          {item.Campanha__c}
                        </Badge>
                      </Flex>
                    </Box>

                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Box>
                    {item.EMAIL__c && <strong>E-mail: &nbsp;</strong>}
                    {item.EMAIL__c}
                  </Box>
                  <Box>
                    {getTelephoneOrCellPhoneNumber(
                      item.TELEFONE__c,
                      item.CELULAR__c
                    ) && <strong>Número de Contato: &nbsp;</strong>}
                    {getTelephoneOrCellPhoneNumber(
                      item.TELEFONE__c,
                      item.CELULAR__c
                    )}
                  </Box>
                  <Button
                    w="100%"
                    borderRadius="2rem"
                    bg="transparent"
                    border="1px solid gray"
                    my="1rem"
                    onClick={() => {
                      handleDetails(
                        item,
                        selectedStatus.color,
                        selectedStatus.name
                      );
                    }}
                  >
                    Detalhes
                  </Button>
                  <Select
                    h="3rem"
                    w="100%"
                    textAlign="center"
                    borderRadius="2rem"
                    bg={selectedStatus.color}
                    color="#fff"
                    variant="unstyled"
                    placeholder={`Status atual: ${selectedStatus.name}`}
                    // onChange={(e) => {
                    //   handleUpdateLead(e.target.value, item);
                    // }}
                  >
                    {/* {selectedStatus.STATUS__c !== 'oportunidades' && (
                      <option value="Oportunidades" style={{ color: 'black' }}>
                        Novas Oportunidades
                      </option>
                    )}
                    {selectedStatus.STATUS__c !== 'novoContato' && (
                      <option value="NovoContato" style={{ color: 'black' }}>
                        Fazer novo contato
                      </option>
                    )}
                    {selectedStatus.STATUS__c !== 'emNegociaocao' && (
                      <option value="EmNegociaocao" style={{ color: 'black' }}>
                        Em negociação
                      </option>
                    )}
                    {selectedStatus.STATUS__c !== 'concluido' && (
                      <option value="Concluido" style={{ color: 'black' }}>
                        Concluído
                      </option>
                    )} */}
                  </Select>
                </AccordionPanel>
              </AccordionItem>
            );
          })
        ) : (
          <Box
            w="100%"
            mt="1rem"
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Spinner />
          </Box>
        )}
        {leads?.length <= 0 && (
          <Box>
            <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-mt-12">
              <svg
                width="75"
                height="75"
                viewBox="0 0 75 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                  fill="#D2D2D2"
                />
              </svg>
              <p className="tw-mt-2 tw-text-[#828282]">
                Você não possui leads nesse status
              </p>
            </div>
          </Box>
        )}
      </Accordion>
      <Modal
        closeOnOverlayClick={true}
        isOpen={isOpenDetails}
        onClose={onCloseDetails}
        size="6xl"
      >
        <ModalOverlay />
        <ModalHeader></ModalHeader>
        <ModalContent textAlign="center">
          <ModalBody mt="1rem">
            <Box pb="1rem">
              <Box
                w="100%"
                bg="#FFFFF"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <ModalCloseButton color="black" />

                <Text fontWeight="bold" fontSize="2.3vh">
                  Detalhes da campanha
                </Text>
              </Box>
              <Box borderBottom="1px solid #E3E3E3" w="100%" h="0" my="1rem" />

              <Box display="flex" flexDir="column">
                <Box
                  w="100%"
                  bg="#E3E3E3"
                  borderRadius="0.4rem"
                  mr="2%"
                  px="0.5rem"
                  py="2vh"
                >
                  <Accordion
                    allowMultiple
                    sx={{
                      '&::-webkit-scrollbar': {
                        width: '0.4rem',
                        borderRadius: '8px',
                        backgroundColor: `rgba(0, 0, 0, 0.05)`
                      },
                      '&::-webkit-scrollbar-thumb': {
                        borderRadius: '8px',
                        backgroundColor: `#939393`
                      }
                    }}
                  >
                    <AccordionItem
                      mt="1rem"
                      bg="#fff"
                      borderRadius="0.5rem"
                      borderLeft={`4px solid ${selectedStatus.color}`}
                    >
                      <h2>
                        <AccordionButton>
                          <Box flex="1" textAlign="left">
                            <Text>Detalhes do Cliente</Text>
                          </Box>

                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4}>
                        <Box
                          display="flex"
                          flexDir="column"
                          alignItems="flex-start"
                        >
                          <Box display="flex">
                            <Text fontWeight="bold" pr="0.2vw">
                              Dados de criação:
                            </Text>
                            <Text>
                              {format(
                                new Date(details?.CreatedDate || 0),
                                "dd/MM/yyyy 'às' HH:mm"
                              )}
                            </Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              ID_MDM:
                            </Text>
                            <Text>{details.ID_MDM__c || ''}</Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              E-mail:
                            </Text>

                            <Text>{details.EMAIL__c || ''}</Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Nome:
                            </Text>
                            <Text>{details.NOME__c || ''}</Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text
                              fontWeight="bold"
                              whiteSpace={'nowrap'}
                              pr="0.2vw"
                            >
                              Número de Contato:
                            </Text>
                            <Text>
                              {getTelephoneOrCellPhoneNumber(
                                details.TELEFONE__c,
                                details.CELULAR__c
                              )}
                            </Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Segmento:
                            </Text>
                            <Text>{details.SEGMENTO__c || ''}</Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Nome Estipulante:
                            </Text>
                            <Text>{details.NOME_ESTIPULANTE__c || ''}</Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Produto Atual:
                            </Text>
                            <Text>{details.PRODUTOR_ATUAL__c || ''}</Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              CPF/CPNJ:
                            </Text>
                            <Text>
                              {details.CPF__c?.length === 11
                                ? details.CPF__c.replace(
                                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                                    '$1.$2.$3-$4'
                                  )
                                : details.CPF__c?.replace(
                                    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                                    '$1 $2 $3/$4-$5'
                                  ) || ''}
                            </Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Quantidade de Vidas:
                            </Text>
                            <Text>
                              {details.QuantidadeVida__c
                                ? details.QuantidadeVida__c
                                : ' -'}
                            </Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Quantidade de Segurados:
                            </Text>
                            <Text>
                              {details.QuantidadeSegurados__c
                                ? details.QuantidadeSegurados__c
                                : ' -'}
                            </Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Profissão:
                            </Text>
                            <Text>
                              {details.PROFISSAO__c
                                ? details.PROFISSAO__c
                                : ' -'}
                            </Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Data de Nascimento:
                            </Text>
                            <Text>
                              {details.DataNascimento__c
                                ? formatDisplayDate(details.DataNascimento__c)
                                : ' -'}
                            </Text>
                          </Box>
                        </Box>
                      </AccordionPanel>
                    </AccordionItem>
                    <AccordionItem
                      mt="1rem"
                      bg="#fff"
                      borderRadius="0.5rem"
                      borderLeft={`4px solid ${selectedStatus.color}`}
                    >
                      <h2>
                        <AccordionButton>
                          <Box flex="1" textAlign="left">
                            <Text>Detalhes da Campanha</Text>
                          </Box>

                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4}>
                        <Box
                          display="flex"
                          flexDir="column"
                          alignItems="flex-start"
                        >
                          <Text fontWeight="bold" mb="1vh">
                            Detalhes da Campanha
                          </Text>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Campanha:
                            </Text>
                            <Text>{details.Campanha__c || ''}</Text>
                          </Box>
                          <Box display="flex" alignItems="flex-start" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Lote:
                            </Text>
                            <Text>{details.LOTE__c || ''}</Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Data campanha:
                            </Text>
                            <Text>{details.DATA_CAMPANHA__c || ''}</Text>
                          </Box>
                          <Box
                            display="flex"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                            gap={1}
                          >
                            <Text textAlign="start" fontWeight="bold">
                              Objetivo campanha:
                            </Text>
                            <Text textAlign="start" gap={1}>
                              {details.OBJETIVO_CAMPANHA__c || ''}
                            </Text>
                          </Box>
                          <Box display="flex" gap={1}>
                            <Text fontWeight="bold" pr="0.2vw">
                              Descritivo campanha:
                            </Text>
                            <Text>{details.DESCRITIVO_CAMAPANHA__c || ''}</Text>
                          </Box>
                        </Box>
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>
                </Box>
              </Box>
              <Box>
                <Box mt="1.5rem" w="100%" bg="#E3E3E3" borderRadius="0.4rem">
                  <Box display="flex" justifyContent="space-between" h="3rem">
                    <Flex alignItems="center" px="1rem">
                      <Text fontWeight="bold" pr="0.2vw">
                        Corretora:
                      </Text>
                      <Text>{details.NOME_CORRETOR__c || ''}</Text>
                    </Flex>
                    <Flex
                      alignItems="center"
                      bg="#001E64"
                      gap="1"
                      px="1rem"
                      borderRadius="0 0.4rem 0.4rem 0"
                    >
                      <Text color="white" fontWeight="bold">
                        EV:
                      </Text>
                      <Text color="white">
                        {details.ESTRUTURA_VENDA__c || ''}
                      </Text>
                    </Flex>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box
                  mt="1.5rem"
                  w="100%"
                  bg="#E3E3E3"
                  borderRadius="0.4rem"
                  px="2vh"
                  py="2vh"
                >
                  <Box display="flex" flexDir="column" alignItems="flex-start">
                    <Text fontWeight="bold" pr="0.2vw">
                      Histórico:
                    </Text>
                    <Box
                      display="flex"
                      alignItems="center"
                      mb="1rem"
                      flexDir="column"
                      w="100%"
                    >
                      {!historyLoading && history?.length > 0 ? (
                        <TableContainer
                          maxH="16rem"
                          overflowY="scroll"
                          alignItems="center"
                        >
                          <Table variant="striped" colorScheme="gray" w="100%">
                            <Thead w="100%">
                              <Tr>
                                <Th>Motivo</Th>
                                <Th isNumeric>Horário</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {history.map((item: any, index: any) => {
                                return (
                                  <>
                                    <Tr key={index}>
                                      <Td>
                                        {(item.TIPO_LOG__c === 'Atualizado' &&
                                          setReason(
                                            item.ABORDAGEM_N3__c === '' ||
                                              item.ABORDAGEM_N3__c === null
                                              ? item.ABORDAGEM_N2__c
                                              : item.ABORDAGEM_N3__c
                                          )) ||
                                          ''}{' '}
                                        {item.TIPO_LOG__c === 'Percepção' &&
                                          'Percepção do contato: ' +
                                            item.PERCEPCAO__c}
                                        {item.TIPO_LOG__c === 'Agendamento' &&
                                          'Agendou contato com lead para: ' +
                                            new Intl.DateTimeFormat('pt-BR', {
                                              timeZone: 'UTC'
                                            }).format(
                                              new Date(
                                                item.DATA_AGENDAMENTO__c
                                                  ?._seconds * 1000
                                              )
                                            )}
                                        {item.TIPO_LOG__c === 'Distribuição' &&
                                          'Distribuição'}
                                        {item.TIPO_LOG__c ===
                                          'Redistribuição' && 'Redistribuição'}
                                        {item.TIPO_LOG__c === 'Visualizado' &&
                                          'Visualizado'}
                                      </Td>
                                      <Td isNumeric>
                                        <Box
                                          display="flex"
                                          justifyContent="flex-end"
                                        >
                                          <Box>
                                            {' '}
                                            {item.DATA_ULTIMA_ALTERACAO__c !==
                                              '' &&
                                              item.DATA_ULTIMA_ALTERACAO__c &&
                                              item.DATA_ULTIMA_ALTERACAO__c}
                                          </Box>
                                        </Box>
                                      </Td>
                                    </Tr>
                                  </>
                                );
                              })}
                            </Tbody>
                          </Table>
                        </TableContainer>
                      ) : historyLoading ? (
                        <Box>
                          <Spinner />
                        </Box>
                      ) : (
                        <Box>
                          <Text>Nenhum histórico para esse lead</Text>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
